/* eslint-disable no-plusplus */
function arrayBufferToBase64(arrayBuffer: any) {
  const uint8Array = new Uint8Array(arrayBuffer);
  let binaryString = '';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < uint8Array.length; i++) {
    binaryString += String.fromCharCode(uint8Array[i]);
  }
  return window.btoa(binaryString);
}

function base64ToArrayBuffer(base64: any) {
  const binaryString = window.atob(base64);
  const { length } = binaryString;
  const uint8Array = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  return uint8Array.buffer;
}

export function createFileDetails(file: File) {
  const url = URL.createObjectURL(file);
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      const stringsDecoded = arrayBufferToBase64(reader.result);
      resolve({
        name: file.name,
        type: file.type,
        url,
        content: stringsDecoded,
      });
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

export function parseFileDetailsToFile(fileDetails: any) {
  // Convert the content back to a Blob
  const blob = new Blob([base64ToArrayBuffer(fileDetails.content)], { type: fileDetails.type });

  // Create a new File object
  const file = new File([blob], fileDetails.name, { type: fileDetails.type });

  return file;
}
